import React, { Component } from 'react';
import update from 'immutability-helper';
import PhotoSortItem from './PhotoSortItem';

class PhotoSortContainer extends Component {
  constructor(props) {
    super(props);
    this.moveCard = this.moveCard.bind(this);
    this.state = {
      cards: this.props.images.map(this.getCards)
    }
  }

  getCards = (x, i) => {
    var obj = {}
    if (x.name) {
      obj = {
        id: i,
        src: URL.createObjectURL(x),
        name: x.name
      }
      return obj;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.images !== prevProps.images) {
      this.setState({ cards: this.props.images.map(this.getCards) });
    }
  }

  moveCard(dragIndex, hoverIndex) {
    const { cards } = this.state;
    const dragCard = cards[dragIndex];

    this.setState({ dragIndex, hoverIndex });

    this.setState(
      update(this.state, {
        cards: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
        },
      }),
    );

    this.sendData(this.state.cards);
  }

  sendData = (cards) => {
    let sortedCards =
      cards.map((x) => {
        return x.name;
      });
    this.props.newCardsList(sortedCards);
  }

  render() {
    const cards = this.state.cards;

    return (
      <div>
        <div className="sort-list">
          {cards.map((card, i) => (
            <PhotoSortItem
              key={card.id}
              index={i}
              id={card.id}
              src={card.src}
              moveCard={this.moveCard}
              name={card.name}
            />
          ))}
        </div>
      </div>
    );
  }
}
export default PhotoSortContainer;
